var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"embedContainer",staticClass:"embed-container",class:_vm.mainWrapperClass},[_c('div',{ref:"pdfHolder",staticClass:"pdf-holder"})])
}
var staticRenderFns = []

export { render, staticRenderFns }